export default {"src":"/_next/static/media/smart-offices.2b9f07f2.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};